import React, { Fragment } from 'react'
import { string, bool, func } from 'prop-types'
import VerticalNameChildren from '../../../components/library/layout/VerticalNameChildren'
import HrbTranslate from '../../../components/language/HrbTranslate'
import EmdashText from '../../../components/library/common/EmdashText'
import DateTime from '../../../components/library/common/DateTime'
import Button from '../../../components/library/buttons/Button'
import { FileCopyOutlined } from '@mui/icons-material';
import CollapsibleCardContent from '../../../components/library/stacking-collapsible-cards/CollapsibleCardContent';
import ReturnStatusIcon from '../components/ReturnStatusIcon';
import { FilingStatus } from '../services/FilingStatus';

const FilingStatusRow = ({ loading, submissionType, filingStatus, confirmationNumber, dateIssued, errorMessage, copyJson, copyXml, isRefile, refileIndex }) => {
    return <CollapsibleCardContent className='py-3 light-grey'>
        <div className='column is-4 ml-0 pl-0'>
            <h4><HrbTranslate text={`ReturnInfo.FilingStatusLabels.${submissionType}`} /></h4>
            {copyXml &&
                <Button elementId={`btn-copy-xml-${confirmationNumber}`} disabled={filingStatus === '' || filingStatus === 'PAPERFILED'} buttonStyles='secondary mt-4' onClick={() => copyXml()} labelKey='ReturnStatus.ButtonLabel.CopyXml' />
            }
            {copyJson && !isRefile &&
                <Button elementId={`btn-copy-json-${confirmationNumber}`} disabled={filingStatus === ''} buttonStyles='secondary mt-4' onClick={() => copyJson()} textLast = 'true' labelKey={copyXml ? 'ReturnInfo.Labels.CopyFiledJson' : 'ReturnInfo.Labels.NetFileJson'} ><FileCopyOutlined id='launch-tpsc-icon' /></Button>
            }
            {copyJson && isRefile &&
                <Button elementId={`btn-copy-json-${confirmationNumber}`} disabled={filingStatus === ''} buttonStyles='secondary mt-4' onClick={() => copyJson()} textLast='true' labelKey={copyXml ? 'ReturnInfo.Labels.CopyFiledJson' : 'ReturnInfo.Labels.ReFileJson'} params={{ index: refileIndex-1 }} ><FileCopyOutlined id='launch-tpsc-icon' /></Button>
            }
        </div>
        <div className='column is-4'>
            {filingStatus &&
                <div style={{ marginBottom: '10px' }}>
                <VerticalNameChildren textKey={`ReturnInfo.Labels.${submissionType}`} loading={loading}>
                    {filingStatus ?
                        <p className='p1 medium-weight'><HrbTranslate text={`ReturnInfo.FilingStatus.${filingStatus}`} /></p> :
                        <p className='p1 medium-weight'><EmdashText /></p>
                    }
                </VerticalNameChildren>
                </div>
            }
            <VerticalNameChildren textKey='ReturnInfo.Labels.ConfirmationNumber' loading={loading}>
                {confirmationNumber ?
                    <p className='p1 bold-weight'>{confirmationNumber}</p> :
                    <p className='p1 bold-weight'><EmdashText /></p>
                }
            </VerticalNameChildren>
        </div>
        <div className='column is-4 mr-0 pr-0'>
            <VerticalNameChildren textKey='ReturnInfo.Labels.Issued' loading={loading}>
                {dateIssued ?
                    <p className='p1 bold-weight'><DateTime value={dateIssued} dateAndTime /></p> :
                    <p className='p1 bold-weight'><EmdashText /></p>
                }
            </VerticalNameChildren>
        </div>
        {errorMessage && filingStatus !== 'PAPERFILED' &&
            <Fragment>
                <div className='column is-4' />
                <div className='column is-8 mr-0 pr-0 icon-and-text'>
                    <div className='icon-padding'>
                        <ReturnStatusIcon dashboardStatus={FilingStatus.ERROR} isInline='false' />
                    </div>
                    <p className='p1 error-message'>{errorMessage}</p>
                </div>
            </Fragment>
        }
    </CollapsibleCardContent>
}

FilingStatusRow.propTypes = {
    loading: bool,
    submissionType: string,
    confirmationNumber: string,
    dateIssued: string,
    errorMessage: string,
    copyJson: func,
    copyXml: func
}

export default FilingStatusRow